// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ouKne","content":"styles_content__-9Gc0","checkbox":"styles_checkbox__2DbVw","checkboxLabel":"styles_checkboxLabel__8YDIH"};